import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { suggestTowns } from "@/api/event-about";

/**
 * The town suggestions a host picks from, each with its time zone: the zone
 * follows the town's state, so it is never typed.
 */
export function TownLookup() {
  const [q, setQ] = useState("");
  const { data, error } = useQuery({
    queryKey: ["town-suggestions", q],
    queryFn: () => suggestTowns(q),
    enabled: q.trim().length > 0,
  });

  return (
    <div className="space-y-1">
      <label className="flex items-center gap-2 text-sm">
        <span className="w-40 text-gray-600">Town lookup</span>
        <input className="input w-64" placeholder="Knoxville" value={q} onChange={(e) => setQ(e.target.value)} />
      </label>
      {error && <p className="text-xs text-red-600 pl-40">{(error as Error).message}</p>}
      <ul className="text-xs text-gray-600 pl-40">
        {(data?.data.cities ?? []).map((c) => (
          <li key={c.id}>
            {c.label} · {c.timeZone ?? "no zone held"}
          </li>
        ))}
      </ul>
    </div>
  );
}
